module.exports = __webpack_public_path__ + "static/media/medpad-slide8.1136d742.png";